import React from 'react';
import FooterComp from '../../components/Footer/Footer';
import HeaderComp from '../../components/Header/Header';
import config from '../../config/config';
import ManualHeader from '../../components/Manual/ManualHeader';
import Manual from '../../components/Manual/Manual';
import SetHeaders from '../../config/SetHeaders';
import seo from '../../config/seo';
import Head from 'next/head'
import axios from 'axios';

const ManualContainer = ({ Header, Body, Footer, response }: any) => {

  const components = (typeName: any, compData: any, key: any) => {
    switch (typeName) {
      case 'connect.page-heading-widget':
        return <ManualHeader key={key} data={compData} />;
      case 'faq.button-with-label':
        return <Manual key={key} data={compData} />;

      default:
        return null;
    }
  };
  return (
    <React.Fragment>
      {response && !response.Seo && (
        <Head>
          <title>{seo.manuals}</title>
        </Head>
      )}
      {response && <SetHeaders HEADERS={response} />}
      {Header && <HeaderComp HeaderValue={Header} />}
      <div className="app-body">
        {Body &&
          Body.map((data: any, i: number) => {
            return components(data.__component, data, i);
          })}
      </div>
      {Footer && <FooterComp data={Footer} />}
    </React.Fragment>
  );
};

export async function getStaticProps() {
  const { data } = await axios.get(config.endpoints.manuals)
  return {
    props: {
      Header: data.Header,
      Body: data.Body,
      Footer: data.Footer.Footer,
      response: data
    },
    revalidate: 3600
  }
}

export default ManualContainer
